export const getSessionStorageItem = (itemName: string) => {
  if (typeof window === 'undefined') {
    return null;
  }
  return sessionStorage.getItem(itemName);
}

export const setSessionStorageItem = (itemName: string, itemValue: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(itemName, itemValue);
}

export const getLocalStorageItem = (itemName: string) => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(itemName);
}

export const setLocalStorageItem = (itemName: string, itemValue: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(itemName, itemValue);
}
